import React from 'react';
import { chlorine, lead, emerging, nitrates, minerals } from 'images';
import styles from './styles.scss';

const FirstAnswer = () => (
  <div className={styles.firstAnswer}>
    <div className={styles.items}>
      <div className={styles.item}>
        <img src={chlorine} alt="Chlorine" />
        <span>Chlorine</span>
      </div>
      <div className={styles.item}>
        <img src={lead} alt="Lead" />
        <span>Lead</span>
      </div>
      <div className={styles.item}>
        <img src={emerging} alt="Emerging Contaminants" />
        <span>Emerging Contaminants</span>
      </div>
    </div>
    <div className={styles.items}>
      <div className={styles.item}>
        <img src={nitrates} alt="Nitrates" />
        <span>Nitrates</span>
      </div>
      <div className={styles.item}>
        <img src={minerals} alt="Minerals" />
        <span>Minerals (TDS)</span>
      </div>
    </div>
  </div>
);

export default FirstAnswer;
